// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"ErrorBoundary_errorContainer__3EdkZ","errorMsg":"ErrorBoundary_errorMsg__rFX-T","homeBtn":"ErrorBoundary_homeBtn__2piep"};